/**
 * Returns the value type for the value field.
 * TODO: When adding trigger values, add to this function to return v.TRIGGER if value is a trigger value.
 */
export const getValueTypeDropdownValue = (props: Record<string, any>): string => {
  const { valueType } = props;
  return valueType;
};
